var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ZCode"},[_c('codemirror',{staticStyle:{"height":"100%"},attrs:{"options":_vm.option},on:{"ready":_vm.ready,"input":_vm.input,"changes":_vm.changes},model:{value:(_vm.computedVal),callback:function ($$v) {_vm.computedVal=$$v},expression:"computedVal"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a02beb62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/bri-vtools/src/components/other/ZCode.vue
// module id = null
// module chunks = 